import { useCallback } from 'react';
import useIsTrialEnabled from './useIsTrialEnabled';

const TRIAL_URLS: string[] = [
    '/ProjectList.jsp',
    '/TaskList.jsp',
    '/HelpMat.jsp',
    '/SLAScreen.jsp',
    '/Statistics.jsp',
    '/CIList.jsp',
    '/AssetManagementDash.jsp',
    '/SystemList.jsp',
    '/System.jsp',
    '/SoftwareList.jsp',
    '/PatchManagementList.jsp',
    '/CatalogList.jsp',
    '/AvailabilityLog.jsp',
    '/SupplierList.jsp',
    '/OnlineUsersList.jsp',
    '/SubTabList.jsp',
];

const useIsTrialUrl = (): (url: string) => boolean => {
    const isTrialEnabled = useIsTrialEnabled();

    return useCallback((url: string) => {
        if (!isTrialEnabled) {
            return false;
        }
        return TRIAL_URLS.some(trialUrl => url.startsWith(trialUrl));
    }, [isTrialEnabled]);
}

export default useIsTrialUrl;